import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute,RouteConfigLoadEnd,RouteConfigLoadStart } from '@angular/router';
import { TranslationService } from '../shared-module/common/services/translation.service';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap, delay } from 'rxjs/operators';
import { HeaderService } from './header/header.service';
import { BehaviorSubject } from 'rxjs';
import { SpinnerService } from './spinner/spinner.service';
import { CurrentUser } from '../shared-module/common/services/current-user.service';
import { TenantSettings } from '../shared-module/common/services/tenant-settings.service';
import { ElementResizeObserverService } from '../shared-module/common/services/element-resize-observer.service';
import {CompanionService} from "../providers-module/companion/companion.service";
import {CompanionModel} from "../providers-module/companion/companion.model";

@Component({
    selector: 'root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  public currentPage: string;
  public warningMsg: string;
  public toggledSidemenu: boolean = false;
  public titleChanged = new BehaviorSubject<string>(null);
  public companion: CompanionModel;

  constructor(private router: Router,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translationService: TranslationService,
    private headerService: HeaderService,
    private spinnerService: SpinnerService,
    private currentUser: CurrentUser,
    private companionService: CompanionService,
    private tenantSettings: TenantSettings) {
  }

  ngOnInit() {
    this.setTitle();
    this.setLang();
    this.loadSapCompanionScript();
    this.navigateToTopOfPage();
    this.headerService.titleChanged.pipe(delay(0)).subscribe((currentPage: string) => {
      this.currentPage = currentPage;
    });
    this.headerService.warningMsg.pipe(delay(0)).subscribe((msg) => {
      this.warningMsg = msg;
    });
  }

  ngAfterViewInit() {
    this.router.events.pipe(
      filter((event) => event instanceof RouteConfigLoadStart))
      .subscribe(() => {
        this.spinnerService.toggleSpinner(true);
      });

    this.router.events.pipe(
      filter((event) => event instanceof RouteConfigLoadEnd))
      .subscribe(() => {
        this.spinnerService.toggleSpinner(false);
      });
}

  private navigateToTopOfPage() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let setupContent = document.getElementsByClassName('setup-content')[0];
        if (setupContent) {
          setupContent.scrollTo(0, 0);
        }
      });
  }

  private setTitle() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      .subscribe((event) => {
        const helpLinkKey = this.tenantSettings.useNewQuoteEngine ? (event['helpLinkNewQuote'] || event['helpLink']) : event['helpLink'];
        this.headerService.urlChanged.next(helpLinkKey);
        const title = this.translationService.translate(event['title']);
        this.headerService.titleChanged.next(title);
        this.titleService.setTitle(title);
      });
  }

  private setLang() {
    document.documentElement.lang = this.currentUser.dictionaryISOCode;
  }

  public toggleSidemenu(){
    // Timeout for page to load in order to resize the elements
    setTimeout(() => {
      ElementResizeObserverService.resizeElement();
    }, 10);
    this.toggledSidemenu = !this.toggledSidemenu;
  }

  public loadSapCompanionScript() {
    this.companionService.get().subscribe((companion: CompanionModel) => {
      this.companion = companion;
      if (this.companion.sapCompanionUrlPath) {
        let node = document.createElement('script');
        node.src = this.companion.sapCompanionUrlPath;
        node.type = 'text/javascript';
        node.async = true;
        node.defer = true;
        document.getElementsByTagName('body')[0].appendChild(node);
      }
    });
  }
}
